window.addEventListener("DOMContentLoaded", () => {
    function _createClass(Constructor, protoProps, staticProps) {
        return protoProps && _defineProperties(Constructor.prototype, protoProps),
            staticProps && _defineProperties(Constructor, staticProps),
            Constructor
    }

    function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || !1,
                descriptor.configurable = !0,
                "value" in descriptor && (descriptor.writable = !0),
                Object.defineProperty(target, descriptor.key, descriptor)
        }
    }
    var PriceRangeInstance = function () {
        "use strict";
        function PriceRangeInstance(container2) {
            var _this6 = this;
            this.container = container2,
                this.selectors = {
                    inputMin: ".cc-price-range__input--min",
                    inputMax: ".cc-price-range__input--max",
                    control: ".cc-price-range__control",
                    controlMin: ".cc-price-range__control--min",
                    controlMax: ".cc-price-range__control--max",
                    bar: ".cc-price-range__bar",
                    activeBar: ".cc-price-range__bar-active"
                },
                this.controls = {
                    min: {
                        barControl: container2.querySelector(this.selectors.controlMin),
                        input: container2.querySelector(this.selectors.inputMin)
                    },
                    max: {
                        barControl: container2.querySelector(this.selectors.controlMax),
                        input: container2.querySelector(this.selectors.inputMax)
                    }
                },
                this.controls.min.value = parseInt(this.controls.min.input.value === "" ? this.controls.min.input.placeholder : this.controls.min.input.value),
                this.controls.max.value = parseInt(this.controls.max.input.value === "" ? this.controls.max.input.placeholder : this.controls.max.input.value),
                this.valueMin = this.controls.min.input.min,
                this.valueMax = this.controls.min.input.max,
                this.valueRange = this.valueMax - this.valueMin,
                [this.controls.min, this.controls.max].forEach(function (item) {
                    item.barControl.setAttribute("aria-valuemin", _this6.valueMin),
                        item.barControl.setAttribute("aria-valuemax", _this6.valueMax),
                        item.barControl.setAttribute("tabindex", 0)
                }),
                this.controls.min.barControl.setAttribute("aria-valuenow", this.controls.min.value),
                this.controls.max.barControl.setAttribute("aria-valuenow", this.controls.max.value),
                this.bar = container2.querySelector(this.selectors.bar),
                this.activeBar = container2.querySelector(this.selectors.activeBar),
                this.inDrag = !1,
                this.bindEvents(),
                this.render()
        }
        return _createClass(PriceRangeInstance, [{
            key: "getPxToValueRatio",
            value: function () {
                return this.bar.clientWidth / (this.valueMax - this.valueMin)
            }
        }, {
            key: "getPcToValueRatio",
            value: function () {
                return 100 / (this.valueMax - this.valueMin)
            }
        }, {
            key: "setActiveControlValue",
            value: function (value) {
                isNaN(parseInt(value)) || (this.activeControl === this.controls.min ? (value === "" && (value = this.valueMin),
                    value = Math.max(this.valueMin, value),
                    value = Math.min(value, this.controls.max.value)) : (value === "" && (value = this.valueMax),
                        value = Math.min(this.valueMax, value),
                        value = Math.max(value, this.controls.min.value)),
                    this.activeControl.value = Math.round(value),
                    this.activeControl.input.value != this.activeControl.value && (this.activeControl.value == this.activeControl.input.placeholder ? this.activeControl.input.value = "" : this.activeControl.input.value = this.activeControl.value,
                        this.activeControl.input.dispatchEvent(new CustomEvent("change", {
                            bubbles: !0,
                            cancelable: !1,
                            detail: {
                                sender: "theme:component:price_range"
                            }
                        }))),
                    this.activeControl.barControl.setAttribute("aria-valuenow", this.activeControl.value))
            }
        }, {
            key: "render",
            value: function () {
                this.drawControl(this.controls.min),
                    this.drawControl(this.controls.max),
                    this.drawActiveBar()
            }
        }, {
            key: "drawControl",
            value: function (control) {
                control.barControl.style.left = (control.value - this.valueMin) * this.getPcToValueRatio() + "%"
            }
        }, {
            key: "drawActiveBar",
            value: function () {
                this.activeBar.style.left = (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() + "%",
                    this.activeBar.style.right = (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() + "%"
            }
        }, {
            key: "handleControlTouchStart",
            value: function (e) {
                e.preventDefault(),
                    this.startDrag(e.target, e.touches[0].clientX),
                    this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this),
                    this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this),
                    window.addEventListener("touchmove", this.boundControlTouchMoveEvent),
                    window.addEventListener("touchend", this.boundControlTouchEndEvent)
            }
        }, {
            key: "handleControlTouchMove",
            value: function (e) {
                this.moveDrag(e.touches[0].clientX)
            }
        }, {
            key: "handleControlTouchEnd",
            value: function (e) {
                e.preventDefault(),
                    window.removeEventListener("touchmove", this.boundControlTouchMoveEvent),
                    window.removeEventListener("touchend", this.boundControlTouchEndEvent),
                    this.stopDrag()
            }
        }, {
            key: "handleControlMouseDown",
            value: function (e) {
                e.preventDefault(),
                    this.startDrag(e.target, e.clientX),
                    this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this),
                    this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this),
                    window.addEventListener("mousemove", this.boundControlMouseMoveEvent),
                    window.addEventListener("mouseup", this.boundControlMouseUpEvent)
            }
        }, {
            key: "handleControlMouseMove",
            value: function (e) {
                this.moveDrag(e.clientX)
            }
        }, {
            key: "handleControlMouseUp",
            value: function (e) {
                e.preventDefault(),
                    window.removeEventListener("mousemove", this.boundControlMouseMoveEvent),
                    window.removeEventListener("mouseup", this.boundControlMouseUpEvent),
                    this.stopDrag()
            }
        }, {
            key: "startDrag",
            value: function (target, startX) {
                this.controls.min.barControl === target ? this.activeControl = this.controls.min : this.activeControl = this.controls.max,
                    this.dragStartX = startX,
                    this.dragStartValue = this.activeControl.value,
                    this.inDrag = !0
            }
        }, {
            key: "moveDrag",
            value: function (moveX) {
                if (this.inDrag) {
                    var value = this.dragStartValue + (moveX - this.dragStartX) / this.getPxToValueRatio();
                    this.setActiveControlValue(value),
                        this.render()
                }
            }
        }, {
            key: "stopDrag",
            value: function () {
                this.inDrag = !1
            }
        }, {
            key: "handleControlKeyDown",
            value: function (e) {
                e.key === "ArrowRight" ? this.incrementControlFromKeypress(e.target, 10) : e.key === "ArrowLeft" && this.incrementControlFromKeypress(e.target, -10)
            }
        }, {
            key: "incrementControlFromKeypress",
            value: function (control, pxAmount) {
                this.controls.min.barControl === control ? this.activeControl = this.controls.min : this.activeControl = this.controls.max,
                    this.setActiveControlValue(this.activeControl.value + pxAmount / this.getPxToValueRatio()),
                    this.render()
            }
        }, {
            key: "handleInputChange",
            value: function (e) {
                e.target.value = e.target.value.replace(/\D/g, ""),
                    (!e.detail || e.detail.sender != "theme:component:price_range") && (this.controls.min.input === e.target ? this.activeControl = this.controls.min : this.activeControl = this.controls.max,
                        this.setActiveControlValue(e.target.value),
                        this.render())
            }
        }, {
            key: "handleInputKeyup",
            value: function (e) {
                setTimeout(function () {
                    this.value = this.value.replace(/\D/g, "")
                }
                    .bind(e.target), 10)
            }
        }, {
            key: "bindEvents",
            value: function () {
                var _this7 = this;
                [this.controls.min, this.controls.max].forEach(function (item) {
                    item.barControl.addEventListener("touchstart", _this7.handleControlTouchStart.bind(_this7)),
                        item.barControl.addEventListener("mousedown", _this7.handleControlMouseDown.bind(_this7)),
                        item.barControl.addEventListener("keydown", _this7.handleControlKeyDown.bind(_this7)),
                        item.input.addEventListener("change", _this7.handleInputChange.bind(_this7)),
                        item.input.addEventListener("keyup", _this7.handleInputKeyup.bind(_this7))
                })
            }
        }, {
            key: "destroy",
            value: function () { }
        }]),
            PriceRangeInstance
    }();
    if (document.querySelector(".sp-price-range")) {
        new PriceRangeInstance(document.querySelector(".sp-price-range"));
    }
    const event = new Event("ajaxSearchComplete");
    // Listen for the event.
    document.addEventListener(
        "ajaxSearchComplete",
        (e) => {
            if (document.querySelector(".sp-price-range")) {
                new PriceRangeInstance(document.querySelector(".sp-price-range"));
            }
        },
        false,
    );
});